function init() {
	window.GR = window.GR || {};

	if (window.GR.trustpilotReady) {
		createInstances();
	}
	else {
		setupApi();
	}
}

function setupApi() {
	const script = injectTrustpilotScript();
	script.addEventListener('load', () => {
		window.GR.trustpilotReady = true;
		createInstances();
	}, {once: true});
}

function injectTrustpilotScript(onload) {
	const elem = document.createElement('script');
	elem.id = 'trustpilot-widget-js';
	elem.type = 'text/javascript';
	elem.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

	document.head.appendChild(elem);

	return elem;
}

function createInstances() {
	const widgets = document.querySelectorAll('.trustpilot-widget');
	if (!widgets.length) {
		return;
	}

	// see TP docs for usage
	widgets.forEach(elem => {
		window.Trustpilot.loadFromElement(elem, true);
	});
}

const TrustpilotRunner = {
	init,
}

export default TrustpilotRunner;



// WEBPACK FOOTER //
// ./scripts/modules/trustpilot-runner.js